export default __webpack_public_path__ + "static/media/42g.322e8a38.svg";